import {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import FunctionsData from "../../../Functions/FunctionsData";
import moment from "moment/moment";

export default function StaffDashboardRegistrations({setCurrent,setLoadingArray}) {

    const [loading,setLoading] = useState(true);
    const [data,setData] = useState(null);
    const history = useHistory();
    useEffect(() => {
        //console.log('/api/merco/'+props.version);
        FunctionsData.fetchDataGet(
            FunctionsData.getApiUrl('/api/register/open'),
            setData,
            true,
            setLoading
        )

    }, [loading]);

    useEffect(() => {
        if(data) {
            setLoadingArray(!loading ? 0 : 1);
        }
    }, [loading])

    if(loading === true) return null;
    return (
        <div className="dashboard-box">
            <div className="header">
                New vet registrations ({data.length})
            </div>
            <div className="dashboard-content">
                {
                    data?.map((row,idx) => {
                        if(idx > 9) return null;
                        return (
                            <div style={{borderBottom: (idx + 1 === data.length) ? null : '1px solid', paddingBottom:(idx + 1 === data.length) ? null : 10, marginBottom:(idx + 1 === data.length) ? null : 10}}>
                                <strong>Vet</strong>: {row.business_name}&nbsp;
                                <span style={{margin:'0 10px'}}>|</span>
                                <strong>Created</strong>:&nbsp;{moment(row.created_at).format('DD/MM/YYYY')} <span style={{margin:'0 10px'}}>|
								</span>&nbsp;<strong>City</strong>: {row.city}, {row.postcode}
                            </div>
                        )
                    })
                }
            </div>
            <div className="footer">
                <a href={"#"} onClick={(e) => {
                    e.preventDefault();
                    setCurrent("/registrations");
                    history.push("/registrations");
                }}>See all new registrations</a>
            </div>
        </div>
    )

}
